import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { VideoAnalyzerPayload } from '@anytag/graphql';

interface AnalysisScoreChartProps {
  result: VideoAnalyzerPayload;
}

export const AnalysisScoreChart = ({ result }: AnalysisScoreChartProps) => {
  const detailedResults = result.ruleBreakdown;
  const passCount = detailedResults.filter((r) => r.status === 'PASS').length;
  const failCount = detailedResults.filter((r) => r.status === 'FAIL').length;
  const uncertainCount = detailedResults.filter((r) => r.status === 'UNCERTAIN').length;

  const chartData = [
    { name: 'Pass', value: passCount, color: '#40B87C' },
    { name: 'Fail', value: failCount, color: '#FF5F5F' },
    { name: 'Uncertain', value: uncertainCount, color: '#FFB63D' }
  ].filter((d) => d.value > 0);

  return (
    <div className="relative size-24">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={chartData} innerRadius={28} outerRadius={42} dataKey="value" stroke="none">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className={`text-lg font-bold ${
            result.overallScore >= 80
              ? 'text-attention-green'
              : result.overallScore >= 50
                ? 'text-attention-yellow'
                : 'text-attention-red'
          }`}
        >
          {result.overallScore}
        </span>
      </div>
    </div>
  );
};
